import styled from "@emotion/styled";

export const DefaultFooterContainer = styled.div({
    display: "flex",
});
